// Fixed application profile; no shared catalog seed is needed.
export const QUALITY_FIELD_PROFILE = { id:"000000000000000000002920", value:"Control_Calidad_Huerto", label:"Control de Calidad de Huerto" };
export const withQualityFieldProfile = profiles => profiles.some(p => p.value === QUALITY_FIELD_PROFILE.value) ? profiles : [...profiles, QUALITY_FIELD_PROFILE];
